<template>
  <l-button variant="link" @click="openAppzi">
    <slot/>
  </l-button>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"

const openAppzi = () => {
  window.appzi?.openSurvey("094a9bac-6381-481d-bd7b-3b88285d59eb")
}
</script>
